module.exports = __webpack_public_path__ + "static/Connected-Products-564466a0ebcc584eb89b4958be7714e8.jpg";